export default "__VITE_ASSET__AQPo9e7o__"